module.exports = __webpack_public_path__ + "img/152.ea378d3b.jpg";